(function(app) {
    const elements = {
        inputWrapperEl: null,
        widthInputEl: null,
        heightInputEl: null,
        widthDisplayEl: null,
        heightDisplayEl: null,
        widthVisDisplayEl: null,
        heightVisDisplayEl: null,
        sizePickerEl: null,
        widthRangeIndicatorEl: null,
        heightRangeIndicatorEl: null,
        widthRangeProgressEl: null,
        heightRangeProgressEl: null,
    };

    const config = {
        minWidth: 0,
        maxWidth: 0,
        minHeight: 0,
        maxHeight: 0,
        isUpdating: false,
        customSizeEnabled: false
    };

    app.SizeInput = {
        init() {
            elements.inputWrapperEl = document.querySelector('.wdpp-input--text-size-range');
            elements.widthInputEl = document.querySelector('.wdpp-size-input-width');
            elements.heightInputEl = document.querySelector('.wdpp-size-input-height');
            elements.widthDisplayEl = document.querySelector('.wdpp-table-row--size .wdpp-display--width');
            elements.heightDisplayEl = document.querySelector('.wdpp-table-row--size .wdpp-display--height');
            elements.widthVisDisplayEl = document.querySelector('.wdpp-size-vis-text--width');
            elements.heightVisDisplayEl = document.querySelector('.wdpp-size-vis-text--height');
            elements.sizePickerEl = document.querySelector('.wdpp-select--size-picker');
            
            // Safely get range indicator elements with null checks
            const widthRangeEl = document.querySelector('[data-input="width"]');
            const heightRangeEl = document.querySelector('[data-input="height"]');
            elements.widthRangeIndicatorEl = widthRangeEl ? widthRangeEl.closest('.wdpp-size-range-indicator') : null;
            elements.heightRangeIndicatorEl = heightRangeEl ? heightRangeEl.closest('.wdpp-size-range-indicator') : null;
            elements.widthRangeProgressEl = widthRangeEl;
            elements.heightRangeProgressEl = heightRangeEl;

            if (!elements.inputWrapperEl ||
                !elements.widthInputEl ||
                !elements.heightInputEl ||
                !elements.widthDisplayEl || 
                !elements.heightDisplayEl ||
                !elements.sizePickerEl) {
                // Validate required elements
                if (!app.Utils.validateElements('size inputs', {
                    'input wrapper': '.wdpp-input--text-size-range',
                    'width input': '.wdpp-size-input-width',
                    'height input': '.wdpp-size-input-height',
                    'width display': '.wdpp-display--width',
                    'height display': '.wdpp-display--height',
                    'size picker': '.wdpp-select--size-picker'
                })) {
                    return;
                }
            }

            // Get custom size permission from global variable
            config.customSizeEnabled = window.customSizeEnabled || false;

            // Subscribe to store changes
            app.Store.subscribe('size', (size) => {
                if (size) {
                    this.updateDisplays(size.width, size.height);
                }
            });
            
            this.getConfigValues();
            this.initInputEvents();
            this.handleSizePicker();

            app.Store.subscribe('initialized', () => {
                this.updateCustomInputsVisibility();
                
                if (this.isCustomOptionSelected()) {
                    const initialWidth = parseFloat(elements.widthInputEl.value);
                    const initialHeight = parseFloat(elements.heightInputEl.value);
                    if (!isNaN(initialWidth) && !isNaN(initialHeight)) {
                        this.updateSize('width', initialWidth);
                        this.updateSize('height', initialHeight);
                    }
                } else {
                    this.setSizeFromPicker();
                }
            });
        },

        updateCustomInputsVisibility() {
            if (!elements.inputWrapperEl) return;
            
            const isCustomSelected = this.isCustomOptionSelected();
            const shouldShow = config.customSizeEnabled && isCustomSelected;
            
            elements.inputWrapperEl.style.display = shouldShow ? 'flex' : 'none';
        },
        
        updateDisplays(width, height) {
            if (elements.widthDisplayEl) {
                elements.widthDisplayEl.textContent = app.Utils.formatNumber(width);
            }
            if (elements.heightDisplayEl) {
                elements.heightDisplayEl.textContent = app.Utils.formatNumber(height);
            }
            if (elements.widthVisDisplayEl) {
                elements.widthVisDisplayEl.textContent = app.Utils.formatNumber(width) + " cm";
            }
            if (elements.heightVisDisplayEl) {
                elements.heightVisDisplayEl.textContent = app.Utils.formatNumber(height) + " cm";
            }
            
            this.updateRangeIndicators(width, height);
        },

        updateRangeIndicators(width, height) {
            // Update width range indicator
            if (elements.widthRangeProgressEl && elements.widthRangeIndicatorEl) {
                const widthPercent = ((width - config.minWidth) / (config.maxWidth - config.minWidth)) * 100;
                elements.widthRangeProgressEl.style.width = Math.max(0, Math.min(100, widthPercent)) + '%';
                
                // Update visual states based on proximity to limits
                this.updateLimitStates('width', width);
            }
            
            // Update height range indicator
            if (elements.heightRangeProgressEl && elements.heightRangeIndicatorEl) {
                const heightPercent = ((height - config.minHeight) / (config.maxHeight - config.minHeight)) * 100;
                elements.heightRangeProgressEl.style.width = Math.max(0, Math.min(100, heightPercent)) + '%';
                
                // Update visual states based on proximity to limits
                this.updateLimitStates('height', height);
            }
        },

        updateLimitStates(dimension, value) {
            const container = dimension === 'width' 
                ? elements.widthRangeIndicatorEl?.closest('.wdpp-size-input-container')
                : elements.heightRangeIndicatorEl?.closest('.wdpp-size-input-container');
                
            if (!container) return;
            
            const min = dimension === 'width' ? config.minWidth : config.minHeight;
            const max = dimension === 'width' ? config.maxWidth : config.maxHeight;
            const range = max - min;
            const threshold = range * 0.05; // 5% of range for "near limit"
            
            // Remove existing states
            container.classList.remove('near-limit', 'at-limit');
            
            // Check if at or very close to limits
            if (value <= min + threshold || value >= max - threshold) {
                if (value <= min || value >= max) {
                    container.classList.add('at-limit');
                } else {
                    container.classList.add('near-limit');
                }
            }
        },

        updateVisualFeedbackOnly(dimension, inputValue) {
            // Handle Danish decimal format (replace comma with dot)
            const valueForParsing = inputValue.replace(',', '.');
            const numValue = parseFloat(valueForParsing);
            
            // Only update visual feedback if we have a valid number
            if (!isNaN(numValue)) {
                const min = dimension === 'width' ? config.minWidth : config.minHeight;
                const max = dimension === 'width' ? config.maxWidth : config.maxHeight;
                
                // Update progress bar
                const percent = ((numValue - min) / (max - min)) * 100;
                const clampedPercent = Math.max(0, Math.min(100, percent));
                
                if (dimension === 'width' && elements.widthRangeProgressEl) {
                    elements.widthRangeProgressEl.style.width = clampedPercent + '%';
                    this.updateLimitStates('width', numValue);
                } else if (dimension === 'height' && elements.heightRangeProgressEl) {
                    elements.heightRangeProgressEl.style.width = clampedPercent + '%';
                    this.updateLimitStates('height', numValue);
                }
            }
        },

        showRangeIndicator(input) {
            if (input === 'width' && elements.widthRangeIndicatorEl) {
                elements.widthRangeIndicatorEl.classList.add('show');
            } else if (input === 'height' && elements.heightRangeIndicatorEl) {
                elements.heightRangeIndicatorEl.classList.add('show');
            }
        },

        hideRangeIndicator(input) {
            if (input === 'width' && elements.widthRangeIndicatorEl) {
                elements.widthRangeIndicatorEl.classList.remove('show');
            } else if (input === 'height' && elements.heightRangeIndicatorEl) {
                elements.heightRangeIndicatorEl.classList.remove('show');
            }
        },
        
        getConfigValues() {
            config.minWidth = parseFloat(elements.widthInputEl.getAttribute('min') || 0);
            config.maxWidth = parseFloat(elements.widthInputEl.getAttribute('max') || 100);
            config.minHeight = parseFloat(elements.heightInputEl.getAttribute('min') || 0);
			config.maxHeight = parseFloat(elements.heightInputEl.getAttribute('max') || 100);
        },

        calculateProportionalHeight(width) {
            if (isNaN(width) || width === 0) {
                console.warn('Width is invalid');
                return config.minHeight;
            }

            const aspectRatio = app.Utils.getAspectRatio(config.minWidth, config.minHeight);
            const height = width / aspectRatio;
            
            return parseFloat(height.toFixed(1));
        },
        
        calculateProportionalWidth(height) {
            if (isNaN(height) || height === 0) {
                console.warn('Height is invalid');
                return config.minWidth;
            }

            const aspectRatio = app.Utils.getAspectRatio(config.minWidth, config.minHeight);
            const width = height * aspectRatio;
            
            return parseFloat(width.toFixed(1));
        },

        /**
         * Calculate constrained size that respects both width and height limits
         * @param {string} sourceSize - 'width' or 'height' - which dimension was changed
         * @param {number} value - The new value for the source dimension
         * @returns {object} - Object with {width, height} that respects all constraints
         */
        calculateConstrainedSize(sourceSize, value) {
            const aspectRatio = app.Utils.getAspectRatio(config.minWidth, config.minHeight);
            
            let width, height;
            
            if (sourceSize === 'width') {
                // Start with the desired width, clamped to its limits
                width = Math.clamp(value, config.minWidth, config.maxWidth);
                // Calculate proportional height
                height = width / aspectRatio;
                
                // If calculated height exceeds its limits, recalculate both dimensions
                if (height > config.maxHeight) {
                    height = config.maxHeight;
                    width = height * aspectRatio;
                    // Final clamp of width in case the recalculated value exceeds limits
                    width = Math.clamp(width, config.minWidth, config.maxWidth);
                } else if (height < config.minHeight) {
                    height = config.minHeight;
                    width = height * aspectRatio;
                    // Final clamp of width in case the recalculated value exceeds limits
                    width = Math.clamp(width, config.minWidth, config.maxWidth);
                }
            } else {
                // Start with the desired height, clamped to its limits
                height = Math.clamp(value, config.minHeight, config.maxHeight);
                // Calculate proportional width
                width = height * aspectRatio;
                
                // If calculated width exceeds its limits, recalculate both dimensions
                if (width > config.maxWidth) {
                    width = config.maxWidth;
                    height = width / aspectRatio;
                    // Final clamp of height in case the recalculated value exceeds limits
                    height = Math.clamp(height, config.minHeight, config.maxHeight);
                } else if (width < config.minWidth) {
                    width = config.minWidth;
                    height = width / aspectRatio;
                    // Final clamp of height in case the recalculated value exceeds limits
                    height = Math.clamp(height, config.minHeight, config.maxHeight);
                }
            }
            
            // Ensure final values are properly formatted
            return {
                width: parseFloat(width.toFixed(1)),
                height: parseFloat(height.toFixed(1))
            };
        },

        updateSize(sourceSize, value) {
            if (config.isUpdating) {
                console.warn('Already updating size');
                return;
            }

            config.isUpdating = true;
            try {
                // Use the new constrained calculation
                const constrainedSize = this.calculateConstrainedSize(sourceSize, value);
                
                // Update both input fields with dot-formatted values (HTML number inputs require dots)
                elements.widthInputEl.value = constrainedSize.width.toString().replace(',', '.');
                elements.heightInputEl.value = constrainedSize.height.toString().replace(',', '.');

                app.Store.setState('size', constrainedSize);
            } finally {
                config.isUpdating = false;
            }
        },

        handleInput(size, value) {
            // Handle Danish decimal format (replace comma with dot)
            const valueForParsing = value.replace(',', '.');
            const numValue = parseFloat(valueForParsing);
            if (!isNaN(numValue)) {
                this.updateSize(size, numValue);
            } else {
                console.warn('Invalid size input');
            }
        },

        handleFinalValue(size, value) {
            // Handle Danish decimal format (replace comma with dot)
            const valueForParsing = value.replace(',', '.');
            const numValue = parseFloat(valueForParsing);
            if (isNaN(numValue)) {
                console.warn('Invalid size input');
                return;
            }

            const min = size === 'width' ? config.minWidth : config.minHeight;
            const max = size === 'width' ? config.maxWidth : config.maxHeight;
            // Use proper clamping with reasonable bounds
            const clampedValue = Math.min(Math.max(numValue, min), max);

            if (size === 'width') {
                elements.widthInputEl.value = clampedValue.toString().replace(',', '.');
            } else {
                elements.heightInputEl.value = clampedValue.toString().replace(',', '.');
            }

            this.updateSize(size, clampedValue);
        },

        attachSizeEvents(size) {
            const input = size === 'width' ? elements.widthInputEl : elements.heightInputEl;
            
            // Remove existing listeners by replacing the element (prevents duplicates)
            const newInput = input.cloneNode(true);
            input.parentNode.replaceChild(newInput, input);
            
            // Update reference
            if (size === 'width') elements.widthInputEl = newInput;
            if (size === 'height') elements.heightInputEl = newInput;
            
            // Show range indicator on focus
            newInput.addEventListener('focus', () => {
                this.showRangeIndicator(size);
            });

            // Hide range indicator on blur with delay for smooth UX
            newInput.addEventListener('blur', () => {
                setTimeout(() => {
                    this.hideRangeIndicator(size);
                }, 150);
            });

            // Show indicator and update visual feedback only (no calculations)
            newInput.addEventListener('input', (event) => {
                this.showRangeIndicator(size);
                this.updateVisualFeedbackOnly(size, event.target.value);
            });
            
            // Only validate/calculate when user is done editing (change event)
            newInput.addEventListener('change', (event) => {
                this.handleFinalValue(size, event.target.value);
            });
        },

        handleSizePicker() {
            elements.sizePickerEl.addEventListener('change', () => {
                this.updateCustomInputsVisibility();
                this.setSizeFromPicker();
            });
        },

        setSizeFromPicker() {
            const selectedOption = elements.sizePickerEl.options[elements.sizePickerEl.selectedIndex];
            if (selectedOption) {
                const width = parseFloat(selectedOption.getAttribute('data-width'));
                const height = parseFloat(selectedOption.getAttribute('data-height'));
                if (!isNaN(width) && !isNaN(height)) {
                    // Use constrained calculation to ensure predefined sizes also respect limits
                    const constrainedSize = this.calculateConstrainedSize('width', width);
                    elements.widthInputEl.value = constrainedSize.width.toString().replace(',', '.');
                    elements.heightInputEl.value = constrainedSize.height.toString().replace(',', '.');
                    app.Store.setState('size', constrainedSize);
                } else {
                    console.warn('Invalid width or height from size picker');
                }
            }
        },

        initInputEvents() {
            this.attachSizeEvents('width');
            this.attachSizeEvents('height');
        },

        getSize() {
            return app.Store.getState('size') || {
                width: parseFloat(elements.widthInputEl.value) || config.minWidth,
                height: parseFloat(elements.heightInputEl.value) || config.minHeight
            };
        },

        isCustomOptionSelected() {
            if (!elements.sizePickerEl) return false;
            const selectedOption = elements.sizePickerEl.options[elements.sizePickerEl.selectedIndex];
            return selectedOption && selectedOption.value === 'custom';
        },
        
        /**
         * Get the size data for cart export
         * @returns {object} The size data for the cart
         */
        getCartData() {
            const size = this.getSize();
            return {
                width: size.width,
                height: size.height,
                unit: 'cm'
            };
        },

        /**
         * Get the size data for price calculation
         * @returns {object} The size data for the price
         */
        getPriceData() {
            const size = this.getSize();
            return {
                width: size.width,
                height: size.height
            };
        }
    };
})(window.app = window.app || {});